import { render, staticRenderFns } from "./AuidoMessageBalloon.vue?vue&type=template&id=10698ed8&scoped=true&"
import script from "./AuidoMessageBalloon.vue?vue&type=script&lang=js&"
export * from "./AuidoMessageBalloon.vue?vue&type=script&lang=js&"
import style0 from "./AuidoMessageBalloon.vue?vue&type=style&index=0&id=10698ed8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10698ed8",
  null
  
)

export default component.exports